import ContentInfoWrapper from './ContentInfoWrapper';

function install(Vue) {
  Vue.component(ContentInfoWrapper.name, ContentInfoWrapper);
}

export default { install };
